import { useState } from 'react';
import { isAxiosError } from 'axios';
import { registerModuleApi } from '../api';
import { FetchStatus } from 'types/api';

export const useDeleteCompanyMember = () => {
  const [status, setStatus] = useState<FetchStatus>('idle');
  const [errors, setError] = useState<string | null>(null);

  const deleteMember = async (id: number) => {
    setStatus('loading');
    setError(null);
    try {
      await registerModuleApi.deleteMember(id);
      setStatus('success');
    } catch (error) {
      setStatus('failed');
      if (isAxiosError(error)) {
        setError(error.response?.data?.detail ?? 'Failed to delete member');
      } else {
        setError('Something went wrong');
      }
    }
  };

  return { status, errors, deleteMember };
};
